export const TEST_ID = 'timelineItem';

export const SELECTED_TEST_ID = 'selectedTimelineItem';

export const DEFAULT_STATUS = 'inProgress';
